<div class="each-result" [class.disabled]="!assignedLead.is_active">
  @if (!assignedLead.is_active) {
    <div class="inactive-tooltip">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      This lead is inactive
    </div>
  }
  <div class="checkbox-section">
    <label class="checkbox-container">
      <input
        type="checkbox"
        [(ngModel)]="checked"
        (change)="onCheckboxTicked()"
        [disabled]="!assignedLead.is_active"
      />
      <span class="checkmark"></span>
    </label>
    <a
      href="javascript:void(0)"
      class="leads-link"
      (click)="showDetailView()"
      [class.disabled-link]="!assignedLead.is_active"
    >
      <div class="lead-header">
        <div class="assigned-on-utc">
          {{ assignedLead.assigned_on_utc | date: "medium" }}
        </div>
      </div>
      <div class="name-row">
        <div class="name">{{ assignedLead.company_name }}</div>
      </div>
      <div class="location-wrapper">
        <div class="location">{{ assignedLead.short_address }}</div>
        <span
          [id]="'tour-lead-item-source-' + rowId"
          class="source-tag"
          [attr.data-source]="assignedLead.source.toUpperCase()"
          >{{ sourceBadgeLabel }}</span
        >
      </div>
    </a>
  </div>
  <div class="assigned-to">
    <div class="right-actions">
      @if (assignedLead.lead_status) {
        <span
          class="status-badge"
          (click)="showDetailView()"
          (keyup.enter)="showDetailView()"
          tabindex="0"
          [attr.data-status]="assignedLead.lead_status"
          [id]="'tour-lead-item-status-' + rowId"
          >{{ leadStatusLabel }}</span
        >
      }
      <a
        [id]="'tour-lead-item-notes-' + rowId"
        href="javascript:void(0)"
        (click)="assignedLead.is_active && onShowNotes()"
        title="View Notes"
        [class.disabled-action]="!assignedLead.is_active"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18px"
          height="18px"
          viewBox="0 0 640 640"
        >
          <path
            d="M128.1 64C92.8 64 64.1 92.7 64.1 128L64.1 512C64.1 547.3 92.8 576 128.1 576L274.3 576L285.2 521.5C289.5 499.8 300.2 479.9 315.8 464.3L448 332.1L448 234.6C448 217.6 441.3 201.3 429.3 189.3L322.8 82.7C310.8 70.7 294.5 64 277.6 64L128.1 64zM389.6 240L296.1 240C282.8 240 272.1 229.3 272.1 216L272.1 122.5L389.6 240zM332.3 530.9L320.4 590.5C320.2 591.4 320.1 592.4 320.1 593.4C320.1 601.4 326.6 608 334.7 608C335.7 608 336.6 607.9 337.6 607.7L397.2 595.8C409.6 593.3 421 587.2 429.9 578.3L548.8 459.4L468.8 379.4L349.9 498.3C341 507.2 334.9 518.6 332.4 531zM600.1 407.9C622.2 385.8 622.2 350 600.1 327.9C578 305.8 542.2 305.8 520.1 327.9L491.3 356.7L571.3 436.7L600.1 407.9z"
          />
        </svg>
      </a>

      <a
        [id]="'tour-lead-item-unassign-' + rowId"
        href="javascript:void(0)"
        (click)="assignedLead.is_active && onUnassignLead()"
        title="Unassign Lead"
        [class.disabled-action]="!assignedLead.is_active"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18px"
          height="18px"
          viewBox="0 0 640 512"
        >
          <path
            d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7l388.6 0c3.9 0 7.6-.7 11-2.1l-261-205.6z"
          />
        </svg>
      </a>
    </div>
  </div>
  <div
    class="section-with-menu-arrow"
    (click)="assignedLead.is_active && showDetailView()"
    (keydown.enter)="assignedLead.is_active && showDetailView()"
    tabindex="0"
  >
    <!--<span class="labels">Small Business</span>
  <span class="labels green">Green Leads</span> -->
    <ng-container #leadAttributesContainer></ng-container>
    <!-- @if (assignedToMe) {
      <div class="menu-dots">
        <a class="mdots" href="javascript:void(0)" (click)="onOptionsClick()">
          <span></span>
          <span></span>
          <span></span>
        </a>
        @if (showDropDown) {
          <div class="dots-dropdown" (appClickOutside)="closeDropDown()">
            <!-- <a href="javascript:void(0)">Add Note</a>
            <a href="javascript:void(0)">Inquire Form</a> -->
    <!-- <a href="javascript:void(0)" (click)="onUnassignLead()">Unassign</a>
          </div>
        }
      </div>
    } -->
    <a
      href="javascript:void(0)"
      class="right-arrow"
      [class.disabled-arrow]="!assignedLead.is_active"
    >
    </a>
  </div>
</div>

<!-- Notes popup -->
@if (showNotesPopup) {
  <app-record-notes
    [uniqueId]="recordUniqueId"
    [companyName]="assignedLead.company_name"
    (closePopup)="onCloseNotesPopup()"
  ></app-record-notes>
}
